export default __webpack_public_path__ + "static/flyte-logo-b7e8695234d42c012b4a59780d77ad3d.png";